
import React from "react";

const HomeLoadingCards = () => {
    return (
        <div className="w-[20rem] lg:w-[17rem] h-full flex flex-col justify-between overflow-hidden animate-pulse">
            <div className="relative">
                <div className="w-full h-48 bg-blue-300 rounded-xl"></div>
            </div>
            <div className="py-6 space-y-3">
                <div className="h-6 bg-blue-300 rounded-md w-3/4 mx-auto"></div>
                <div className="h-4 bg-blue-300 rounded-md w-5/6 mx-auto"></div>
                <div className="h-4 bg-blue-300 rounded-md w-4/5 mx-auto"></div>
            </div>
            <div className="px-4 mb-4">
                <div className="h-10 w-full bg-blue-300 rounded-full"></div>
            </div>
        </div>
    );
};

export default HomeLoadingCards;
